import {Component} from '@angular/core';

@Component({
    selector: 'acabim-admin-manage-bim-models',
    templateUrl: './manage-bim-models.component.html',
    styleUrls: ['./manage-bim-models.component.scss']
})
export class ManageBimModelsComponent {


}
